<template>
  <div class="group-accred-information__requirement-items">
    <sButton
      v-if="isCreate"
      class="mr-auto"
      data-qa="add-requirement-btn"
      :disabled="disabled || loading"
      icon="plus"
      small
      type="text"
      @click="showModalAddRequirement()">
      {{ $t('groupOfAccreditation.AddRequirement') }}
    </sButton>
    <template v-if="loading">
      <div 
        v-for="n in 3"
        :key="n"
        class="group-accred-information__requirement-item"
        :data-qa="`requirement-item-skeleton-${n}`">
        <v-skeleton-loader
          :height="30"
          loading
          type="card"
          width="100%"/>
        <v-skeleton-loader
          v-if="isEdit"
          loading
          :max-height="30"
          :max-width="30"
          type="card"/>
        <v-skeleton-loader
          v-if="isEdit"
          loading
          :max-height="30"
          :max-width="30"
          type="card"/>
      </div>
    </template>
    <template v-else>
      <div
        v-for="(requirement, index) in mutableRequirements"
        :key="index"
        class="group-accred-information__requirement-item" 
        :data-qa="`requirement-item-${index}`">
        <div
          class="my-auto mr-1 text-left"
          :data-qa="`requirement-item-${index}-text`">
          {{ requirement.name }}
        </div>
        <sButton
          v-if="isEdit"
          class="mr-auto"
          :data-qa="`edit-requirement-${index}-btn`"
          :disabled="disabled"
          icon="edit"
          small
          type="text"
          @click="showModalAddRequirement(index, requirement)"/>
        <sButton
          v-if="isEdit"
          :data-qa="`delete-requirement-${index}-btn`"
          :disabled="disabled"
          icon="delete"
          small
          type="text"
          @click="deleteRequirement(index)"/>
      </div>
      <ModalInputTemplate
        v-if="isCreate || isEdit"
        ref="modalTemplate"
        :callback="callbackModalAddRequirement"
        data-qa="modal-add-requirement"
        :first-button="$t('Common.Save')"
        :form-data="{ text: modalAddRequirement.item.name }"
        :modal-title="$t('groupOfAccreditation.modalEditRequirementTitle')"
        :options="{
          show: modalAddRequirement.show,
          maxLength: 4000 }"
        @close="closeModalAddRequirement"/>
    </template>
  </div>
</template>
<script>
import ModalInputTemplate from 'components/common/dialogs/ModalInputTemplate.vue'

export default {
  name: 'groupOfAccreditationRequirements',
  data() {
    return {
      modalAddRequirement: {
        show: false,
        item: {
          index: null,
          id: null,
          name: ''
        },
        index: null,
      },
    }
  },
  methods: {
    deleteRequirement(index) {
      this.$emit('delete-requirement', index)
      const result = [...this.mutableRequirements]
      result.splice(index, 1)
      this.mutableRequirements = result
    },
    closeModalAddRequirement() {
      this.modalAddRequirement.item.name = ''
      this.modalAddRequirement.index = null
      this.modalAddRequirement.show = false
    },
    showModalAddRequirement(index, requirement) {
      if (requirement) {
        this.modalAddRequirement.item = { ...requirement }
        this.modalAddRequirement.index = index
      } else {
        this.modalAddRequirement.item = { name: '', id: null }
        this.modalAddRequirement.index = null
      }
      this.modalAddRequirement.show = true
    },
    callbackModalAddRequirement(name) {
      const result = [...this.mutableRequirements]
      if (this.modalAddRequirement.index !== null) {
        this.$emit('edit-requirement', {
          index: this.modalAddRequirement.index,
          item: {...this.modalAddRequirement.item, name } 
        })
        result[this.modalAddRequirement.index].name = name
      } else {
        this.$emit('add-requirement', name)
        result.push({ id: null, name })
      }
      this.mutableRequirements = result
    },
  },
  computed: {
    mutableRequirements: {
      get() {
        return this.requirements || []
      },
      set(value) {
        this.$emit('update:requirements', value)
      }
    },
  },
  props: {
    requirements: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    isCreate: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ModalInputTemplate
  },
}
</script>
<style scoped lang="scss">
.group-accred-information {
  &__requirement {
    &-items {
      display: flex;
      flex-direction: column;
      gap: 4px;
    }
    &-item {
      white-space: break-spaces;
      display: grid;
      grid-template-columns: auto 30px 30px;
      gap: 12px;
      align-items: self-start;
      padding: 10px;
      font-size: 12px;
      font-weight: 600;
      background: var(--green_chosen_light);
      border-radius: 5px;
    }
  }
}
</style>
